angular.module("app").factory("stateAliases", function () {

    var aliases = {
        empty: "main.empty",
        addBlock: "main.pages.add",
        viewMedia: "main.media.list",
        viewPopups: "main.popups.list",
        viewSkins: "main.skins.list",
        viewBanners: "main.pages.list.banners",
        editDetailed: "main.pages.editDetailed",
        editItem: "main.pages.editItem",
        createItem: "main.pages.createItem",
        viewNews: "main.pages.list.news",
        viewPromotions: "main.pages.list.promos",
        viewBackgrounds: "main.pages.list.backgrounds",
        viewPages: "main.pages.list.texts",
        viewSystemSettings: "main.configs.general",
        viewMobileSystemSettings: "main.configs.generalMobile",
        viewSkinSettings: "main.configs.general",
        viewMobileSkinSettings: "main.configs.generalMobile",
        viewAvailableSystemSettings: "main.configs.availableConfigs",
        viewMobileAvailableSystemSettings: "main.configs.availableMobileConfigs",
        viewAvailableSkinSettings: "main.configs.skinConfigs",
        viewMobileAvailableSkinSettings: "main.configs.skinMobileConfigs",

        viewPayments: "main.payments",
        viewSkinPayments: "main.skinPayments",
        styles: "main.styles",
        viewProducts: "main.products.exchange",
        viewLoyaltyPoints: "main.products.loyalty",
        reset: "main.reset",
        topMatches: "main.topMatch.list",
        viewLiveCasinoBuilder: "main.pageBuilders.liveCasino",
        viewSkillGamesBuilder: "main.pageBuilders.skillGames",
        viewCustomCss: "main.design.customCss",
        viewMobileCustomCss: "main.design.mobileCustomCss",
        viewLogo: "main.design.logo",
        viewAndroidAppBuilder: "main.applications.androidAppSkinning",
        viewAndroidAppSettings: "main.applications.androidAppSettings",
        viewIosAppSettings: "main.applications.iosAppSettings",

        viewAndroidPromoApp: "main.applications.androidPromoApp",

        /*
         * casino_general_admin_states
         * */

        viewGameProviders: "main.providers.list",
        viewGameCategories: "main.categories.list",
        viewGameThemes: "main.themes.list",
        viewGameFeatures: "main.features.list",

        viewAllGames: "main.games.list",
        viewAllSkinGames: "main.skinGames.list",
        viewSkinGames: "main.casinoGames.list",
        viewGameReleases: "main.gameReleases.list",
        viewJoinGames: "main.games.join",
        viewGamesReference: "main.games.gamesreference",
        viewCategoriesProviders: "main.games.categoriesAndProviders",
        viewCasinoJackpotBanners: "main.games.casinoJackpotBanners",
        viewSkinsProvidersReport: "main.report.skinsAndProviders",
        viewGamesReport: "main.report.games",

        skinGameWinnersList: "main.casinoGames.skinGameWinners.list",
        skinGameWinnersAdd: "main.casinoGames.skinGameWinners.add",
        skinGameWinnersEdit: "main.casinoGames.skinGameWinners.edit",

        viewSkinCategoriesProviders: "main.hiddenGames",
        viewMonitoringTool: "main.monitoring",
        viewCasinoSettings: "main.casinoSettings",
    };

    function setStates (statesAliases, cd) {
        var i = 0;
        while (statesAliases[i]) {
            angular.isDefined(aliases[statesAliases[i]]) && cd(aliases[statesAliases[i]]);
            i++;
        }
    }

    return {
        setStates: setStates,
        getSiteMapArray: function () {
            return function () {
                var siteMap = [];
                Object.keys(aliases).forEach(function (value) {
                    siteMap.push(aliases[value])
                });
                return siteMap
            }()
        }
    }
});
